import { render, staticRenderFns } from "./contentCourseLectureDocument.vue?vue&type=template&id=23330edf&"
import script from "./contentCourseLectureDocument.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports